import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	setAsDefaultButton: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.list.set-as-default-button',
		defaultMessage: 'Set as default',
		description: 'Priority picker toggle button text',
	},
	removePriorityButton: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.list.remove-priority-button',
		defaultMessage: 'Remove priority',
		description: 'Tooltip text for the remove priority button',
	},
});

export default messages;
